export default "__VITE_PUBLIC_ASSET__7c9ec186__"